import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { TextField, Input, Button } from '@material-ui/core';
import BackIcon from '@material-ui/icons/ArrowBack';
import { v4 as uuidv4 } from 'uuid';
import api from '../../../../services/api';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
        width: '100%',
      },
    },
    grid: {
      display: 'flex',
      cursor: 'not-allowed',
      '@media screen and (max-width: 991px)': {
        display: 'block',
      },
      '& > *': {
        margin: theme.spacing(1),
        width: '100%',
        '@media screen and (max-width: 991px)': {
          width: '100%',
        },
      },
    },
    button: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
  }),
);

interface ParamTypes {
  id: string;
}

function formatDate(value?: string | Date) {
  if (!value) return '—';
  const d = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('pt-BR');
}

function BlogVisualizar() {
  const [id, setId] = useState('');
  const params = useParams<ParamTypes>();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [link, setLink] = useState('');
  const [date, setDate] = useState('');
  const [enabled, setEnabled] = useState<boolean | undefined>(undefined);
  const [isNew, setIsNew] = useState(false);

  const classes = useStyles();
  const history = useHistory();

  if (!id) {
    if (params.id) {
      setId(params.id);
    } else {
      setId(uuidv4());
      setIsNew(true);
    }
  }

  useEffect(() => {
    if (!isNew && id) {
      const getData = async () => {
        const response = await api.get(`/blogs/${id}`);
        if (response.status && response.status.toString()[0] === '2') {
          const data = await response.json();
          setTitle(data.title ?? '');
          setDescription(data.description ?? '');
          setLink(data.link ?? '');
          setDate(formatDate(data.date));
          setEnabled(data.enabled);
        }
      };
      getData();
    }
  }, [id, isNew]);

  return (
    <main>
      <div className="cadastrar">
        <div className="grid-box grid-one">
          <div className="card">
            <div className="card-body">
              <div>
                <h1>Blog</h1>
                <form>
                  <Input type="hidden" name="id" value={id} />
                  <div className={classes.grid}>
                    <TextField disabled label="Título" variant="outlined" name="title" value={title} />
                  </div>
                  <div className={classes.grid}>
                    <TextField
                      disabled
                      label="Descrição"
                      variant="outlined"
                      name="description"
                      value={description}
                      multiline
                      rows={3}
                    />
                  </div>
                  <div className={classes.grid}>
                    <TextField disabled label="Link" variant="outlined" name="link" value={link} />
                  </div>
                  <div className={classes.grid}>
                    <TextField disabled label="Data" variant="outlined" name="date" value={date} />
                  </div>
                  <div className={classes.grid}>
                    <TextField
                      disabled
                      label="Ativo"
                      variant="outlined"
                      name="enabled"
                      value={enabled === undefined ? '' : enabled ? 'Sim' : 'Não'}
                    />
                  </div>
                  <div className={classes.button}>
                    <Button
                      variant="contained"
                      color="secondary"
                      size="large"
                      startIcon={<BackIcon />}
                      onClick={() => history.push('/blogs')}
                    >
                      Voltar
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default BlogVisualizar;
